module.exports = __webpack_public_path__ + "arrow-right-black-7d25170d6ce8fd27f7d0.svg";